export enum UsersTypes {
    GET_LIST = '@users/GET_LIST',
    REQUEST_GET_LIST = '@users/REQUEST_GET_LIST',
    ADD_USER = '@users/ADD_USER',
    REQUEST_ADD_USER = '@users/REQUEST_ADD_USER',
    DELETE_USER = '@users/DELETE_USER',
    REQUEST_DELETE_USER = '@users/REQUEST_DELETE_USER',
    EDIT_USER = '@users/EDIT_USER',
    REQUEST_EDIT_USER = '@users/REQUEST_EDIT_USER',
    REQUEST_SEND_GLOBAL_NOTIFICATION = '@users/REQUEST_SEND_GLOBAL_NOTIFICATION',
    USER_ERROR = '@users/USER_ERROR',
    CLEAR_USER_ERROR = '@users/CLEAR_USER_ERROR',
    REQUEST_SEND_USER_NOTIFICATION = '@users/REQUEST_SEND_USER_NOTIFICATION',
    REQUEST_GET_USERS_BY_IDS = '@users/REQUEST_TRY_GET_USERS_BY_IDS',
    GET_USERS_BY_IDS = '@users/GET_USERS_BY_IDS',
}

export type User = {
    uid: string;
    firstName: string;
    lastName: string;
    email: string;
    userName?: string;
    registrationDate: string;
    role: string;
    master?: User;
    missions?: UserMission[];
    contactTypes?: string[];
};

export type UserMission = {
    doneCountStages: number;
    id: string;
    isStarted: boolean;
    isFinished?: boolean;
    stages: UserStage[];
};

export type UserStage = {
    doneCountExercises: number;
    id: string;
    isSeen: boolean;
    surveyStatus?: boolean;
};

export type Notification = {
    type: string;
    status: string;
    userId?: string;
};

export type UsersState = {
    isLoading: boolean;
    error?: string;
    users: User[];
    requestedUserIds: string[];
};

export type UsersAction<Payload> = {
    type: UsersTypes;
    payload: Payload;
};

export type AuthReducer = (state: UsersState, actions: UsersAction<UsersState>) => UsersState;
